const localStorageKey = 'chama-redux-state';

export const clearState = () => {
  localStorage.clear(localStorageKey);
};

export const loadState = () => {
  try {
    const serializedState = localStorage.getItem(localStorageKey);

    if (serializedState === null) {
      return undefined;
    }

    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = state => {
  try {
    const serializedState = JSON.stringify(state);
    // NOTE: browser actually throttle the amount of data per time unit that is
    // written to localStorage, therefore check if it actually has changed and
    // needs to be written
    if (serializedState !== localStorage.getItem(localStorageKey)) {
      localStorage.setItem(localStorageKey, serializedState);
    }
  } catch (err) {
    // ignore write errors
  }
};

export default {
  saveState,
  loadState,
  clearState,
};



// WEBPACK FOOTER //
// ../utils/functions/local-storage.js